import React from 'react';
import { HStack, Box, Text } from '@chakra-ui/react';

interface SettingsMenuItemProps {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  rightElement?: React.ReactNode;
  variant?: 'default' | 'danger';
}

const SettingsMenuItem: React.FC<SettingsMenuItemProps> = ({
  icon,
  label,
  onClick,
  rightElement,
  variant = 'default',
}) => {
  const isDanger = variant === 'danger';

  return (
    <HStack
      as="button"
      w="100%"
      bg="#1C1C1E"
      px={4}
      py={4}
      borderRadius="xl"
      justify="space-between"
      transition="all 0.2s"
      onClick={onClick}
      _hover={{
        bg: isDanger ? 'red.900' : '#252528',
        transform: 'translateX(2px)',
      }}
      _active={{
        bg: isDanger ? 'red.800' : '#2A2A2E',
        transform: 'scale(0.99)',
      }}
    >
      <HStack spacing={3}>
        <Box 
          color={isDanger ? 'red.400' : 'orange.400'}
          fontSize="lg"
        >
          {icon}
        </Box>
        <Text 
          color={isDanger ? 'red.400' : 'white'} 
          fontWeight="medium"
          fontSize="md"
        >
          {label}
        </Text>
      </HStack>
      
      {rightElement || (
        <Text color="gray.600" fontSize="lg">
          ›
        </Text>
      )}
    </HStack>
  );
};

export default SettingsMenuItem;